import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type DeletePropsType = {
  onClick: () => void;
};

export const Delete: React.FC<DeletePropsType> = ({ onClick }) => {
  const { t } = useTranslation('common');

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  const label = t('ACTIONS.DELETE');

  return (
    <Tooltip label={label}>
      <UnstyledButton onClick={handleClick} aria-label={label}>
        <FontAwesomeIcon icon={faTrash} />
      </UnstyledButton>
    </Tooltip>
  );
};
